    document.addEventListener('DOMContentLoaded', function() {
        if (window.location.href.includes('/rewards-program')) {
            let retries = 0;
            const maxRetries = 10;
            const intervalTime = 1000;
                        const style = document.createElement('style');
            style.innerHTML = `
                table {
                    border: none !important;
                }
            `;
            const checkElements = function() {

// Load until elements are found
                const amountDiscountText = document.querySelectorAll('table.bon-table.bon-table-tier.vip-tier-table tbody tr td');

                if (amountDiscountText.length === 0) {
                    retries++;
                    if (retries < maxRetries) {
                        setTimeout(checkElements, intervalTime);
                    } else {
                        console.log('No elements found after maximum retries');
                    }
                    return;
                }

// Update vipTier label
                amountDiscountText.forEach(element => {
                    if (element.textContent.includes('Reward Points for')) {
                        element.textContent = 'Reward Points Bonus Earning Rate';
                    }
               
                });
                        
            };
            setTimeout(checkElements, intervalTime);
        }
    });

